import axios from "axios";
import { useState, useEffect } from "react";
import { fetchAllUsers } from "../../service/user-service";
import { UserInterface } from "../../interface/userInterface";

const UserAdminPage = () => {
  const [allUsers, setAllUsers] = useState<UserInterface[]>([]);

  useEffect(() => {
    async function fetchUsers() {
      try {
        const response = await fetchAllUsers(); // Backend API endpoint to get users
        setAllUsers(response.data);
      } catch (error) {
        console.error("Error fetching users: ", error);
      }
    }
    fetchUsers();
  }, []);

  return (
    <div>
      <h1 className="text-xl font-bold mb-4">User List</h1>
      <div className="overflow-auto">
        <table className="w-full bg-white rounded shadow">
          <thead className="bg-gray-200">
            <tr>
              <th className="p-2 border">Name</th>
              <th className="p-2 border">Role</th>
              <th className="p-2 border">Email Address</th>
              <th className="p-2 border">Contact Number</th>
              <th className="p-2 border">Status</th>
              <th className="p-2 border">City</th>
              <th className="p-2 border">State</th>
            </tr>
          </thead>
          <tbody>
            {allUsers.map((user) => (
              <tr key={user._id} className="hover:bg-gray-100">
                <td className="p-2 border">{user.name}</td>
                <td className="p-2 border">{user?.role}</td>
                <td className="p-2 border">{user.emailAddress}</td>
                <td className="p-2 border">{user.contactNumber}</td>
                <td className="p-2 border">{user.status}</td>
                <td className="p-2 border">{user.city}</td>
                <td className="p-2 border">{user.state}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default UserAdminPage;
